if (!document.getElementById("swatch-scroll-css")) {
  const ss = document.createElement("style");
  ((ss.id = "swatch-scroll-css"),
    (ss.textContent = `[id^="product-"][id$="-color-options"]::-webkit-scrollbar,.sale-card__swatches::-webkit-scrollbar,.fc-card__swatches::-webkit-scrollbar{display:none}[id^="product-"][id$="-color-options"]{max-width:100%;min-width:0;box-sizing:border-box}[id^="product-"][id$="-color-options"] .color-swatch{flex-shrink:0}@media(max-width:699px){[id^="product-"][id$="-color-options"] .color-swatch{--swatch-width:1rem;--swatch-height:1rem}}@media(min-width:700px){.swatch-scroll-arrow{opacity:0;pointer-events:none;transition:opacity .2s ease}.product-card:hover .swatch-scroll-arrow{opacity:1;pointer-events:auto}}@media(hover:none),(pointer:coarse){[id^="product-"][id$="-color-options"],[id^="product-"][id$="-color-options"].invisible{opacity:1!important;visibility:visible!important;display:flex!important}.swatch-scroll-arrow{opacity:1!important;pointer-events:auto!important}}`),
    document.head.appendChild(ss));
}
function createProductImage({
  imageUrl: e,
  altText: t,
  className: o = "",
  version: n = "1706649984",
  primary: r,
  onload: s,
}) {
  const a = e.split("?")[0],
    c = document.createElement("div");
  ((c.className = "product-card__image-wrapper"),
    (c.style.position = "absolute"),
    (c.style.top = 0),
    (c.style.left = 0),
    (c.style.width = "100%"),
    (c.style.height = "100%"),
    (c.style.transition = r
      ? "opacity 0.2s ease-out, transform 0.2s ease-out"
      : ""),
    (c.style.zIndex = r ? 2 : 1),
    (c.style.overflow = "hidden"),
    r && ((c.style.transform = "scale(0.95)"), (c.style.opacity = "0")));
  const i = document.createElement("img");
  ((i.src = `${a}?v=${n}`),
    (i.alt = t),
    (i.loading = "lazy"),
    (i.className = `${o} aspect-natural`),
    (i.style.width = "100%"),
    (i.style.height = "100%"),
    (i.style.objectFit = "cover"));
  return (
    (i.srcset = [200, 300, 400, 500, 600, 700, 800, 900, 1e3, 1200]
      .map((e) => `${a}?v=${n}&width=${e} ${e}w`)
      .join(", ")),
    (i.sizes =
      "(max-width: 699px) 74vw, (max-width: 999px) 38vw, calc(100vw / 4)"),
    (i.onload = () => {
      (r &&
        requestAnimationFrame(() => {
          ((c.style.opacity = "1"), (c.style.transform = "scale(1)"));
        }),
        s?.());
    }),
    c.appendChild(i),
    c
  );
}
function _sharedFormatMoney(cents) {
  var fmt = window.themeVariables?.settings?.moneyFormat || "${{amount}}";
  var d = parseFloat(cents) || 0;
  var amt = d.toFixed(2),
    noD = Math.floor(d).toString(),
    comma = amt.replace(".", ",");
  return fmt
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noD)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noD)
    .replace(/\{\{\s*amount\s*\}\}/, amt);
}
function updatePriceList(e, t, o, a) {
  const n = document.getElementById(`product-card__price-list__${e}`);
  if (!n || !t) return;
  const oldRow = n.querySelector("[data-card-price-row]") || n,
    checkoutPct = Number(oldRow?.dataset?.checkoutDiscountPercent || 0),
    finalPct = Number(oldRow?.dataset?.finalSalePercent || 50),
    checkoutActive =
      String(oldRow?.dataset?.checkoutDiscountActive || "false") === "true",
    price = Number(t?.amount || 0),
    compare = Number(o?.amount || 0),
    hasCompare = compare > price,
    finalTitle = (a || "").includes("Final Sale"),
    row = document.createElement("div");
  row.className = "h-stack gap-2 align-center";
  row.setAttribute("data-card-price-row", "");
  row.dataset.checkoutDiscountPercent = String(checkoutPct);
  row.dataset.checkoutDiscountActive = String(checkoutActive);
  row.dataset.finalSalePercent = String(finalPct);
  const money = (e) => _sharedFormatMoney(Number(e));
  if (hasCompare) {
    const pct = Math.round(((compare - price) * 100) / compare);
    row.innerHTML = `<sale-price class="text-on-sale">${money(price)}</sale-price><compare-at-price class="text-subdued line-through">${money(compare)}</compare-at-price><span class="sale-card__checkout-discount" data-final-sale-pill>${pct}% OFF</span>`;
  } else if (finalTitle) {
    const sale = (price * (100 - finalPct)) / 100;
    row.innerHTML = `<sale-price class="text-on-sale">${money(sale)}</sale-price><compare-at-price class="text-subdued line-through">${money(price)}</compare-at-price><span class="sale-card__checkout-discount" data-final-sale-pill>${finalPct}% OFF</span>`;
  } else if (checkoutActive && checkoutPct > 0) {
    const sale = (price * (100 - checkoutPct)) / 100;
    row.innerHTML = `<sale-price class="text-on-sale" data-card-sale-price>${money(sale)}</sale-price><compare-at-price class="text-subdued line-through" data-card-compare-price>${money(price)}</compare-at-price><span class="sale-card__checkout-discount" data-card-discount-pill>${checkoutPct}% OFF</span>`;
  } else {
    row.innerHTML = `<price-list class="price-list"><sale-price class="text-sm text-subdued"><span class="sr-only">Sale price</span>${money(price)}</sale-price></price-list>`;
  }
  oldRow.matches?.("[data-card-price-row]")
    ? oldRow.replaceWith(row)
    : ((n.innerHTML = ""), n.appendChild(row));
}
const showColorVariations = (e) => {
    document
      .getElementById(`product-${e}-color-options`)
      ?.classList.remove("invisible");
  },
  getShowVariations = (e, t) => {
    const o = document.getElementById(`product-${e}-color-options`);
    if ("true" !== o?.dataset?.filled) {
      const t = `      {        product(id: "gid://shopify/Product/${e}") {          title          variationProducts: metafield(namespace: "custom", key: "variation_products") {            type            value            references(first: 50) {              nodes {                ... on Product {                  id                  title                  handle                  images(first: 5) {                    edges {                      node {                        url                      }                    }                  }                  colorVariant: metafield(namespace: "custom", key: "Variation_value") {                    value                  }                  prices: variants(first: 1) {                    edges {                      node {                        price {                          amount                          currencyCode                        }                        compareAtPrice {                          amount                          currencyCode                        }                      }                    }                  }                }              }            }          }        }      }      `;
      fetch("https://mediclo.myshopify.com/api/2025-01/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token":
            "1614833e228a2fd41f3070e8c72058f8",
        },
        body: JSON.stringify({ query: t }),
      })
        .then((e) => e.json())
        .then((t) => {
          const n = t.data.product?.variationProducts?.references?.nodes || [];
          if (!o) return;
          let r = t.data.product.title.trim().split(/\s+/)[0];
          n.filter((e) => e.title.includes(r))
            .sort((a, b) => {
              const aSelected = String(a.id.split("/").pop()) === String(e);
              const bSelected = String(b.id.split("/").pop()) === String(e);
              return aSelected ? -1 : bSelected ? 1 : 0;
            })
            .forEach((t, n) => {
              const r = t.colorVariant.value,
                s = window.parsedColorMap[r] || r,
                a = document.createElement("span");
              if (
                ((a.className =
                  "color-swatch color-swatch--circle color-swatch--sm " +
                  (String(t.id.split("/").pop()) === String(e)
                    ? "is-selected"
                    : "")),
                (a.style.background = `linear-gradient(to right, ${s}, ${s})`),
                (a.style.cursor = "pointer"),
                (a.title = r),
                String(t.id.split("/").pop()) === String(e))
              ) {
                const t = document.getElementById(
                  `product-${e}-selected-color`,
                );
                t && (t.textContent = r);
              }
              a.onclick = function (n) {
                (o
                  .querySelectorAll("span.color-swatch")
                  .forEach((e) => e.classList.remove("is-selected")),
                  a.classList.add("is-selected"));
                const s = document.querySelector(`#product-card__media-${e}`);
                if (!s) return;
                const c = t.images?.edges.map((e) => e.node.url) || [],
                  i = s.querySelector(".product-card__image--primary"),
                  d = s.querySelector(".product-card__image--secondary"),
                  l = () => {
                    (i?.remove(), d?.remove());
                  };
                ((s.style.position = "relative"),
                  (s.href = `/products/${t.handle}`));
                let p = t.prices.edges[0].node.price,
                  m = t.prices.edges[0].node.compareAtPrice;
                updatePriceList(e, p, m, t.title);
                const cardEl = s.closest(".product-card"),
                  titleEl = cardEl?.querySelector("a.product-title");
                if (titleEl) {
                  titleEl.textContent = t.title;
                  titleEl.href = `/products/${t.handle}`;
                }
                const u = document.getElementById(
                  `product-${e}-selected-color`,
                );
                if (u) u.textContent = r;
                const figure = s.closest(".product-card__figure");
                const carousel = figure?.querySelector(".product-card__image-carousel");
                if (carousel) {
                  carousel.style.opacity = "0";
                    const currentWidth = carousel.offsetWidth;
                    const newSlides = c.slice(0, 5).map((url) => {
                    const slide = document.createElement("div");
                    slide.className = "product-card__carousel-slide";
                    slide.style.cssText = "";
                    const img = document.createElement("img");
                    img.src = url;
                    img.alt = r;
                    img.loading = "lazy";
                    img.className = "product-card__image product-card__image--primary";
                    img.style.cssText = "width:100%;height:auto;";
                    slide.appendChild(img);
                    return slide;
                  });
                  carousel.replaceChildren(...newSlides);
                  carousel.scrollTo({ left: 0, behavior: "instant" });
                  const bar = figure?.querySelector(".product-card__carousel-progress-bar");
                  if (bar) bar.style.width = "0%";
                  setTimeout(() => {
                    carousel.style.opacity = "1";
                  }, 50);
                }

              const staticPrimary = [...s.querySelectorAll(".product-card__image--primary")]
                  .find(img => !img.closest(".product-card__image-carousel"));
                if (staticPrimary && c[0]) {
                  staticPrimary.src = c[0];
                  staticPrimary.srcset = "";
                }
                const staticSecondary = s.querySelector(".product-card__image--secondary");
                if (staticSecondary && c[1]) {
                  staticSecondary.src = c[1];
                  staticSecondary.srcset = "";
                }


              };
              (o.appendChild(a), (o.dataset.filled = "true"));
            });
          const wrap = o.parentElement;
          if (wrap) {
            ((wrap.style.position = "relative"),
              (wrap.style.gap = "0"),
              (o.style.padding = "5px 1.75rem 5px .5rem"),
              (o.style.scrollbarWidth = "none"));
            const removeArrows = () => {
                wrap
                  .querySelectorAll(".swatch-scroll-arrow")
                  .forEach((e) => e.remove());
              },
              canScroll = () =>
                o.children.length > 0 && o.scrollWidth > o.clientWidth + 2,
              updateArrows = () => {
                if (!canScroll()) return void removeArrows();
                let e = wrap.querySelector(".swatch-scroll-arrow--prev"),
                  t = wrap.querySelector(".swatch-scroll-arrow--next");
                (e ||
                  ((e = document.createElement("button")),
                  (e.className =
                    "swatch-scroll-arrow swatch-scroll-arrow--prev"),
                  (e.type = "button"),
                  e.setAttribute("aria-label", "Previous colors"),
                  (e.textContent = "←"),
                  (e.onclick = function () {
                    o.scrollBy({ left: -80, behavior: "smooth" });
                  }),
                  wrap.insertBefore(e, o)),
                  t ||
                    ((t = document.createElement("button")),
                    (t.className =
                      "swatch-scroll-arrow swatch-scroll-arrow--next"),
                    (t.type = "button"),
                    t.setAttribute("aria-label", "Next colors"),
                    (t.textContent = "→"),
                    (t.onclick = function () {
                      o.scrollBy({ left: 80, behavior: "smooth" });
                    }),
                    wrap.appendChild(t)));
                const n =
                  "position:absolute;top:50%;z-index:2;width:1.75rem;height:1.75rem;display:inline-flex;align-items:center;justify-content:center;border:0;color:#111;cursor:pointer;padding:0;font-size:1rem;line-height:1;transform:translateY(-50%);";
                ((e.style.cssText =
                  n +
                  "left:0;background:linear-gradient(to right,rgba(255,255,255,.98) 0%,rgba(255,255,255,.82) 38%,rgba(255,255,255,.42) 72%,rgba(255,255,255,0) 100%);"),
                  (t.style.cssText =
                    n +
                    "right:0;background:linear-gradient(to left,rgba(255,255,255,.98) 0%,rgba(255,255,255,.82) 38%,rgba(255,255,255,.42) 72%,rgba(255,255,255,0) 100%);"));
                const r = o.scrollLeft <= 2,
                  s = o.scrollLeft + o.clientWidth >= o.scrollWidth - 2;
                ((e.style.display = r ? "none" : "inline-flex"),
                  (t.style.display = s ? "none" : "inline-flex"));
              };
            (o.addEventListener("scroll", updateArrows),
              setTimeout(updateArrows, 200),
              setTimeout(updateArrows, 600),
              "ResizeObserver" in window &&
                new ResizeObserver(updateArrows).observe(o));
          }
        })
        .catch(console.error);
    }
    t &&
      document
        .getElementById(`product-${e}-color-options`)
        ?.classList.remove("invisible");
  },
  hideColorVariations = (e) => {
    if (window.matchMedia("(hover: none), (pointer: coarse)").matches) return;
    document
      .getElementById(`product-${e}-color-options`)
      ?.classList.add("invisible");
  };
function initCarousels() {
  document.querySelectorAll(".product-card__image-carousel").forEach((c) => {
    if (c.dataset.scrollInited) return;
    c.dataset.scrollInited = "true";
    const figure = c.closest(".product-card__figure");
    if (!figure) return;
    c.addEventListener(
      "scroll",
      () => {
        const progress = figure.querySelector(".product-card__carousel-progress-bar");
        if (progress) {
          const slideCount = c.querySelectorAll(".product-card__carousel-slide").length;
          const thumbPct = slideCount > 1 ? (1 / slideCount) * 100 : 100;
          const max = c.scrollWidth - c.clientWidth;
          const scrollPct = max > 0 ? c.scrollLeft / max : 0;
          const maxOffset = 100 - thumbPct;

          progress.style.width = thumbPct + "%";
          progress.style.left = (scrollPct * maxOffset) + "%";
        }
      },
      { passive: true }
    );
    let _lastW = c.clientWidth;
    new ResizeObserver(() => {
      const w = c.clientWidth;
      if (w === _lastW) return;
      _lastW = w;
      c.scrollTo({ left: 0, behavior: "instant" });
    }).observe(c);
  });
}

    document.addEventListener("DOMContentLoaded", initCarousels);

    new MutationObserver(() => initCarousels()).observe(document.body, {
    childList: true,
    subtree: true,
    });


    (function () {
  if (window.__medicloShopThisColor) return;
  window.__medicloShopThisColor = true;

  var selectedColorLabel = null;

  function updateLinks(colorLabel) {
    document.querySelectorAll('[data-shop-this-color]').forEach(function (link) {
      var genderPrefix = link.getAttribute('data-gender-prefix');
      link.href = '/collections/' + genderPrefix + colorLabel.trim().toLowerCase().replace(/\s+/g, '-') + '-scrubs';
    });
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-product-variation-title]');
    if (!swatch) return;
    var srOnly = swatch.querySelector('.sr-only');
    if (!srOnly) return;
    selectedColorLabel = srOnly.textContent.trim();
    updateLinks(selectedColorLabel);
  }, true);

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest('[data-product-variation-title]');
    if (!swatch) return;
    var srOnly = swatch.querySelector('.sr-only');
    if (srOnly) updateLinks(srOnly.textContent.trim());
  }, true);

  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest('[data-product-variation-title]');
    if (!swatch) return;
    if (selectedColorLabel) updateLinks(selectedColorLabel);
  }, true);
})();